import { AxiosResponse } from "axios";

import { sendRawRequest } from "../request/axios";
import { AxiosHttpError } from "../types/error.type";
import { PasswordReset } from "../types/user.type";

export async function resetPassword(input: PasswordReset) {
  try {
    const res = await sendRawRequest<PasswordReset, AxiosResponse>(
      "post",
      "/auth/password-reset/confirm/",
      input
    );
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return { data: res.data, success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}
